export const JURISPRUDENCIA_MODULE_NAME = "jurisprudencia_module";

export const jurisprudenciaModuleMenuItem = {
  icon: "gavel",
  path: "/jurisprudencia",
};

export const jurisprudenciaModuleRoutes = [
  {
    path: "jurisprudencia",
    name: "JurisprudenciaBusqueda",
    components: {
      default: () => import("./pages/JurisprudenciaBusqueda.vue"),
    },
    meta: {
      title: "Jurisprudencia",
      requiresAuth: true,
      requiresModule: JURISPRUDENCIA_MODULE_NAME,
    },
  },
];

export default {
  moduleName: JURISPRUDENCIA_MODULE_NAME,
  routes: jurisprudenciaModuleRoutes,
  menuItem: jurisprudenciaModuleMenuItem,
};
